import { useFormik } from "formik";
import MomentumSchema from "./momentumSchema";

export const useMomentumFormConfig = () => {
  const momentumForm = useFormik({
    initialValues: {
      momentumAlgos: [],
      availableBudget: 0,
      tradeBudget: 0,
      budgetPerTrade: 0,
      tradeType: "B",
      runProcessType: "Instant",
      scheduleHour: 0,
      scheduleMin: 0,
      stopProfit: 3,
      stopLoss: 3,
      scanInterval: 60000,
    },
    validationSchema: MomentumSchema,
    onSubmit: async () => {},
  });

  const populateValues = (budgetConfig) => {
    if (!budgetConfig) return;
    momentumForm.setFieldValue("availableBudget", budgetConfig.tradeBalance);
    momentumForm.setFieldValue("tradeBudget", budgetConfig.tradeBalance ?? budgetConfig.tradeBudget);
    momentumForm.setFieldValue("budgetPerTrade", budgetConfig.budgetPerTrade);
  };

  return { momentumForm, populateValues };
};
